import { render, staticRenderFns } from "./TaskTypes.vue?vue&type=template&id=4b4a04a4"
import script from "./TaskTypes.vue?vue&type=script&lang=js"
export * from "./TaskTypes.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports